module.exports = __webpack_public_path__ + "images/68851ab789a084e502a4a70e7867dc11.png";